export enum SponsoredPlaylistNavigation {
  Playlist = 'playlist',
  Audience = 'audience',
  Cover = 'cover',
  Info = 'info',
  Review = 'review'
}

export type SponsoredPlaylistNavigationType = 'playlist' | 'audience' | 'cover' | 'info' | 'review';
